import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DadosService } from '../../db/dados.service';
import { ActivatedRoute } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
import { SubCategorias } from '../../../../models/subCategorias.model';
import {  Produtos,IProdutos } from '../../../../models/produtos.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mostrar-produto-subCategoria',
  templateUrl: './mostrar-produto-subCategoria.component.html',
  styleUrls: ['./mostrar-produto-subCategoria.component.css']
})
export class MostrarProdutoSubCategoriaComponent 
implements OnInit, OnDestroy {
  dadosEvent:Subscription;  
  @Input()
  codigo:number;

  produtoClass: Produtos;
  produtos: IProdutos[]=[];
  constructor(private dados:DadosService, private params:ActivatedRoute,
    private db:AngularFirestore) {
      this.produtoClass = new Produtos(this.db,0,false);
      this.dadosEvent = this.produtoClass.changedEvent.subscribe(
        d=>{
          console.log("produtos",d);
          this.produtos = d.sort(function(a:any,b:any) {return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);} );
        }
      )
      console.log(this.params.snapshot.params);
    }

  ngOnInit() {
    if (this.params.snapshot.params.codigo)
      this.getProdutosSubCateg(Number(this.params.snapshot.params.codigo));
  }
  ngOnDestroy(){
    this.dadosEvent.unsubscribe();
  }

  getProdutosSubCateg( codSubCateg:number )
  { 
    console.log( 'Sub-Categoria', codSubCateg);

    if (codSubCateg==null){
      this.codigo = this.params.snapshot.params.categoria;
    } else
    {
      this.codigo = codSubCateg;
    }
    this.produtoClass.snapshot(
       r=>{
        console.log("where:",this.codigo); 
        return r.where("subCategoria","==",Number(this.codigo) )
               .where("inativo","==",false); 
        }
    )
  }

}
